import { Validator } from 'vee-validate';

const validate = {
    custom: {
        name:{
            required: '( ກະລຸນາປ້ອນກ່ອນ... )',
        },
        tel:{
            required: '( ກະລຸນາປ້ອນກ່ອນ... )',
            min: '( ເບີໂທບໍ່ຄວນໜ້ອຍກວ່າ 6 ໂຕເລກ... )',
            max: '( ເບີໂທບໍ່ຄວນເກີນ 15 ໂຕເລກ... )',
        },
        email:{
            required: '( ກະລຸນາປ້ອນກ່ອນ... )',
            max: '( ອີເມວບໍ່ຄວນຍາວກ່ວາ 255 ໂຕ... )'
        },
        part:{
            required: '( ກະລຸນາເລືອກກ່ອນ... )',
        },
        province:{
            required: '( ກະລຸນາເລືອກກ່ອນ... )',
        },
        district:{
            required: '( ກະລຸນາເລືອກກ່ອນ... )',
        },
        village:{
            required: '( ກະລຸນາເລືອກກ່ອນ... )',
        },
        prefix:{
            required: '( ກະລຸນາປ້ອນກ່ອນ... )',
        }
    }
};

export const ValidateCallCenter = (Vue) => {
    Validator.localize('en', validate);
    Vue.$validator.localize('en', validate);
}